import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import FilesForm from '../../service-request-manager/components/FilesForm';

class PatientInsuranceForm extends React.Component {
  
  renderField = ({
    input,
    label,
    placeholder,
    type,
    disabled,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-9">
          <input
            {...input}
            className="form-control"
            placeholder={placeholder}
            type={type}
            disabled={disabled}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
  );

  renderForms = ({ 
    label,
    type,
    disabled,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-9">
        <FilesForm filesABC={this.props.initialValues.files} insuranceId={this.props.initialValues.id} label={label} onFileSubmit={this.onFilesChange}></FilesForm>
      </div>
    </div>
  );

  onFilesChange = (val) => {
    this.props.change('files', val);
  }
  
  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Athena - Add Patient Insurance</legend>
          <Field
            component={this.renderField}
            label="Athena Practice ID"
            type="text"
            placeholder="23284"
            disabled={true}
          />
          <Field
            className="form-control"
            name="name"
            component={this.renderField}
            type="text"
            placeholder="Name"
            label="Name"
          />
          <Field
            className="form-control"
            name="email"
            component={this.renderField}
            type="text"
            placeholder="Email"
            label="Email"
          />
          <Field
            className="form-control"
            name="files"
            component={this.renderForms}
            label="File"
          />
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save & Upload
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  }
 
  return errors;
};

PatientInsuranceForm = connect(state => ({
  formValues: getFormValues('insurance')(state),
  initialValues: state.integrationsmanager.insurance,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'insurance' })(PatientInsuranceForm));
export default PatientInsuranceForm;



// WEBPACK FOOTER //
// ./src/routes/integrations/components/PatientInsuranceForm.js